document.addEventListener('DOMContentLoaded', function () {
    function updateColumnHeights() {
        let screenWidth = document.body.clientWidth;

        if (screenWidth < 768) return;

        document.querySelectorAll('.ats_vacancy_highlight').forEach(function (vacancySection) {
            let vacancyGrid = vacancySection.querySelector('.vacancy-grid');
            if (!vacancyGrid) return;
            let column1, column2, column3;
            let columnHeights = [[], [], []];

            if (screenWidth >= 1024) {
                column1 = vacancyGrid.querySelectorAll('.item:nth-child(3n+1)');
                column2 = vacancyGrid.querySelectorAll('.item:nth-child(3n+2)');
                column3 = vacancyGrid.querySelectorAll('.item:nth-child(3n+3)');
            } else {
                column1 = vacancyGrid.querySelectorAll('.item:nth-child(2n+1)');
                column2 = vacancyGrid.querySelectorAll('.item:nth-child(2n+2)');
                column3 = [];
            }

            function getColumnHeights(column, heightArray) {
                heightArray.length = 0;
                column.forEach(function (element) {
                    heightArray.push(element.offsetHeight + 37);
                });
            }

            function calculateElementsHeight(arr) {
                return arr.reduce((total, current) => total + current, 0);
            }

            function setContainerHeight(container) {
                let maxHeight;
                if (screenWidth >= 1024) {
                    maxHeight = Math.max(
                        calculateElementsHeight(columnHeights[0]),
                        calculateElementsHeight(columnHeights[1]),
                        calculateElementsHeight(columnHeights[2])
                    );
                } else {
                    maxHeight = Math.max(
                        calculateElementsHeight(columnHeights[0]),
                        calculateElementsHeight(columnHeights[1])
                    );
                }
                container.style.height = maxHeight + 'px';
            }

            getColumnHeights(column1, columnHeights[0]);
            getColumnHeights(column2, columnHeights[1]);
            if (screenWidth >= 1024) getColumnHeights(column3, columnHeights[2]);

            setContainerHeight(vacancyGrid);

            let observer = new MutationObserver(() => {
                getColumnHeights(column1, columnHeights[0]);
                getColumnHeights(column2, columnHeights[1]);
                if (screenWidth >= 1024) getColumnHeights(column3, columnHeights[2]);

                setContainerHeight(vacancyGrid);
            });

            observer.observe(vacancyGrid, { childList: true });

            window.addEventListener('resize', updateColumnHeights);
        });
    }

    updateColumnHeights();
});
